import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { DrawSlider } from "source/app/presentation/RadialSurvivalGuide/Slider/DrawSlider";
import { RandomizeSurvivalGuideSelection } from "source/app/presentation/RadialSurvivalGuide/Value/RandomizeSurvivalGuideSelection";
import { ShowSurvivalGuideLabel } from "source/app/presentation/RadialSurvivalGuide/Value/ShowRadialValue";
import { ShareState } from "../../../../services/UI/State/ShareState";

export function SurvivalGuide() {
    const [isVisible, setIsVisible] = React.useState(false);
    const [label, setLabel] = React.useState<string>(`hello`);

    ShareState(
        ESharedFunction.RadialSurvivalGuide_isVisible,
        isVisible,
        setIsVisible
    );

    if (!isVisible) {
        return null;
    }

    return (
        <div
            style={{
                pointerEvents: `auto`,
                textAlign: `center`,
                margin: `30px`,
            }}
        >
            <div
                style={{
                    position: "relative",
                    display: "inline-block",
                }}
            >
                <ShowSurvivalGuideLabel {...{ survivalGuideLabel: label }} />
                <RandomizeSurvivalGuideSelection />
                <DrawSlider {...{ setValue: setLabel }} />
            </div>
        </div>
    );
}
